import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import { GetReportChartByReportId } from '../../../../../store/NTX/Reports/ReportShape/reportShapeSlice';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useGetChartShapesList from '../../../../../hooks/NTX/useGetChartShapesList';

interface props {
  setID: React.Dispatch<React.SetStateAction<string>>; // For Update
}

const ReportChartList: React.FC<props> = props => {
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const { t, i18n } = useTranslation();
  const { ChartShapesList } = useGetChartShapesList();

  useEffect(() => {
    if (id) {
      dispatch(GetReportChartByReportId(id));
    }
  }, [dispatch, id]);

  const { ReportChartByReportIdList } = useAppSelector(state => state.ReportShape);

  return (
    <>
      <div className='row'>
        <div className='col-lg-12 m-auto'>
          <div className='table-responsive rounded-2 text-center  '>
            <table className='table table-hover'>
              <thead className='bg-theme bg-opacity-30'>
                <tr>
                  <th>{t('Current_Charts')} </th>
                  <th>{t('Shape')} </th>
                  <th className='text-end'></th>
                </tr>
              </thead>

              <tbody>
                {ReportChartByReportIdList &&
                  ReportChartByReportIdList?.map((item, idx) => (
                    <tr key={++idx}>
                      <td className='align-middle'>{i18n.language === 'ar' ? item.name2 : item.name}</td>

                      <td className='align-middle'>
                        <i
                          className={`${ChartShapesList?.find(f => f.id === item.shapeId)?.icon}
                               text-theme fs-3 `}
                        ></i>
                        {i18n.language === 'en'
                          ? ChartShapesList?.find(f => f.id === item.shapeId)?.name
                          : ChartShapesList?.find(f => f.id === item.shapeId)?.name2}
                      </td>

                      <td className='align-middle text-end'>
                        <button
                          type='button'
                          className='btn btn-outline-theme'
                          data-bs-toggle='modal'
                          data-bs-target='#UpdateReportShape'
                          onClick={() => props.setID(item.id)}
                        >
                          <i className='far fa-lg fa-fw me-1 fa-edit'></i>

                          {t('Edit')}
                          {/* <i className="far fa-lg fa-fw m-2 fa-edit"></i> */}
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportChartList;
